export default {
  albums: []
};
